import { DrawerModal } from '@fagmobler/ui';
import { ServerProduct } from '@/lib/janitsjar/Product';
import Link from 'next/link';
import Divider from '@/cataloguePages/productPageWithVariants/components/Divider';
import { Fragment } from 'react';

type PropertiesProps = {
  product: ServerProduct;
  openedModal: string | null;
  closeModal: () => void;
  filterGroup?: string;
};

export const PropertiesModalKey = 'properties';

export default function Properties({
  product,
  openedModal,
  closeModal,
  filterGroup,
}: PropertiesProps) {
  const properties = filterGroup
    ? product.properties.filter((prop) => prop.group.code === filterGroup)
    : product.properties;

  return (
    <DrawerModal
      isOpen={openedModal === PropertiesModalKey}
      onClose={closeModal}
      title="Mål"
    >
      <div className="p-4 md:p-6 flex flex-col gap-2 items-start">
        <h1 className="hd-base">Produktets mål</h1>
        <div className="grid grid-cols-[auto_1fr] gap-2 items-center mb-10 md:mb-5">
          {properties.map((prop, index) => (
            <Fragment key={index}>
              <span className="cap-sm font-bold">{prop.label}:</span>
              <p className="body-sm">
                {prop.value} {prop.unit}
              </p>
            </Fragment>
          ))}
        </div>
        <Divider />
      </div>
    </DrawerModal>
  );
}
